<template>
  <svg
    width="24"
    height="26"
    fill="none"
    viewBox="0 0 24 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-width="2"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12.0007 1V3.76923M4.24308 13.9231C4.24308 9.30769 5.21277 3.76923 12.0007 3.76923C18.7885 3.76923 19.7582 9.30769 19.7582 13.9231C19.7582 18.5385 22.6673 21.3077 22.6673 21.3077H1.33398C1.33398 21.3077 4.24308 18.5385 4.24308 13.9231ZM15.8794 21.3077C15.8794 21.3077 15.8794 25 12.0007 25C8.12186 25 8.12186 21.3077 8.12186 21.3077H15.8794Z"
    />
  </svg>
</template>
